import { BusinessPhotosScreen } from '@/screens/business/business-photos-screen';
export default BusinessPhotosScreen;
